import dateFormat from 'date-fns/format'
import { log } from './log'

export function formatPrice(price: number, defaultValue: string = '￥0'): string {
  if (!price) {
    return defaultValue
  }

  return price.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })
}

export class DateFormat {
  static readonly endOfEarlyMonth = 10
  static readonly endOfMidMonth = 20

  /**
   * 日付を yyyy/mm/dd 形式に変換
   * @param date
   */
  static yyyyMmDd(date: Date): string {
    return dateFormat(date, 'YYYY/MM/DD')
  }

  /**
   * 日付に応じてx月上旬/中旬/下旬の文字列形式に置換する
   * 変換後の表記は日本語なので、入力されたdateのTZに関わらず内部ではJSTに変換したうえで日本語表記への変換を行う
   * @param date 日付
   */
  static partOfMonth(date: string | Date): string {
    try {
      const d = new Date(date)
      const parts = new Intl.DateTimeFormat('ja-JP', {
        timeZone: 'Asia/Tokyo',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      }).formatToParts(d)
      const year = parts.find(p => p.type === 'year')!.value
      const month = parts.find(p => p.type === 'month')!.value
      const day = Number(parts.find(p => p.type === 'day')!.value)

      if (day <= DateFormat.endOfEarlyMonth) {
        return `${year}年${month}月上旬`
      }

      if (DateFormat.endOfEarlyMonth < day && day <= DateFormat.endOfMidMonth) {
        return `${year}年${month}月中旬`
      }

      return `${year}年${month}月下旬`
    } catch (error) {
      // 不正な文字列が入力されるなどで変換できなかった場合はログだけ出して `-` を返す
      log.error({ error })

      return '-'
    }
  }

  static validate(dateStr: string): boolean {
    const date = new Date(dateStr)

    // When date string is invalid, IE might return NaN, while other browsers return Date type with 'Invalid Date' value
    return date && date.toString() !== 'Invalid Date'
  }
}

export function formatPoint(point: number): string {
  return `${point}${pointUnit}`
}

export const pointUnit = 'pt'
